<template>
    <b-modal ref="warningModal" title="Warning" @ok="confirmAction" centered>
        <slot>{{ confirmText }}</slot>
    </b-modal>
</template>
  
  <script>
  export default {
    props: ['confirmText'],
    methods: {
        confirmAction() {
            this.$emit('action-confirmed');
        },
        openModal() {
            this.$refs.warningModal.show();
        },
    },
  };
  </script>